var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccodion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron-down",
    transform: "translate(-328 -444)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 24,
    height: 24,
    transform: "translate(352 468) rotate(180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M10.59,7.4,6,2.826,1.41,7.4,0,5.992,6,0l6,5.992Z",
    transform: "translate(346 459.7) rotate(180)",
    fill: "#60677d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccodion);
export default __webpack_public_path__ + "static/media/accodion.3968473f0338f339c8db003b9fc03aa1.svg";
export { ForwardRef as ReactComponent };